import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Col } from "reactstrap"
import GenericMatrixRenderer from "components/Matrix/GenericMatrixRenderer"
import CvmListRenderer from "components/Matrix/renderers/CvmListRenderer"

const DecoderResults = memo(({ 
  apiResponse,
  localMatrixData, 
  templateConfig, 
  onBitToggle,
  currentHexValue
}) => {
  const matrixData = templateConfig.pageKey === 'cvmList' ? null : 
    (localMatrixData || apiResponse?.resultData?.matrixData?.bytes);
  const builderData = apiResponse?.resultData?.builder;
  
  const hasValidInput = currentHexValue && currentHexValue.trim() !== '' && 
    !(templateConfig.pageKey === 'cvmList' && currentHexValue.match(/^0+$/));
  const hasMatrixData = matrixData && (
    (Array.isArray(matrixData) && matrixData.length > 0) ||
    (typeof matrixData === 'object' && Object.keys(matrixData).length > 0)
  );
  
  return (
    <Col md={9}>
        <div className="content-wrapper" style={{ minHeight: '200px' }}>
          {templateConfig.pageKey === 'cvmList' && apiResponse?.resultData && hasValidInput && (
            <div className="cvm-container">
              <CvmListRenderer apiResponse={apiResponse} />
            </div>
          )}
          {templateConfig.hasMatrix && hasMatrixData && hasValidInput && templateConfig.pageKey !== 'cvmList' && (
              <div className="matrix-container">
                <GenericMatrixRenderer 
                  data={matrixData}
                  showExpandToggle={true}
                  defaultExpanded={false}
                  onBitToggle={onBitToggle}
                  builderData={builderData}
                  pageKey={templateConfig.pageKey}
                  currentHexValue={currentHexValue}
                />
              </div>
          )}
        </div>
    </Col>
  )
})

// Added display name because of eslint errors
DecoderResults.displayName = 'DecoderResults'

DecoderResults.propTypes = {
  apiResponse: PropTypes.object,
  localMatrixData: PropTypes.object,
  templateConfig: PropTypes.object.isRequired,
  onBitToggle: PropTypes.func,
  currentHexValue: PropTypes.string
}

export default DecoderResults
